/** True unless the store is explicitly not entitled to POS. */
export const isPosEnabledForStore = (user) =>
  user?.subsystem_access?.pos_enabled !== false;
